module.exports = __webpack_public_path__ + "static/melchers-logo-85ff81915a658aeb7eb7dc6e1fde372e.jpeg";